import { STATUS_COLOR } from '@constants/transaction';
import { DARK_VIOLET } from '@styles/colors';
import { INTER } from '@styles/fonts';
import styled from 'styled-components';

// Icon components
import topUpIcon from '@assets/icons/ActivityTopUp.svg'
import redeemIcon from '@assets/icons/ActivityRedeem.svg'
import mintingIcon from '@assets/icons/ActivityMinting.svg'
import rewardIcon from '@assets/icons/ActivityReward.svg'
import paymentMadeIcon from '@assets/icons/ActivityPaymentMade.svg'
import paymentReceivedIcon from '@assets/icons/ActivityPaymentReceived.svg'
import p2pTransferIcon from '@assets/icons/ActivityP2PTransfer.svg'

export const TopUp = styled.img.attrs({ src: topUpIcon })`
  width: 38px;
  height: 38px;
`;
export const Redeem = styled.img.attrs({ src: redeemIcon })`
  width: 38px;
  height: 38px;
`;
export const Minting = styled.img.attrs({ src: mintingIcon })`
  width: 38px;
  height: 38px;
`;
export const Reward = styled.img.attrs({ src: rewardIcon })`
  width: 38px;
  height: 38px;
`;
export const PaymentMade = styled.img.attrs({ src: paymentMadeIcon })`
  width: 38px;
  height: 38px;
`;
export const PaymentReceived = styled.img.attrs({ src: paymentReceivedIcon })`
  width: 38px;
  height: 38px;
`;
export const P2PTransfer = styled.img.attrs({ src: p2pTransferIcon })`
  width: 38px;
  height: 38px;
`;

// New wrapper container
export const WrapperContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

// Container components
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 8px;
  cursor: pointer;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  gap: 4px;
`;

export const RightSide = styled.div<{ $hasAmount: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: ${({ $hasAmount }) => $hasAmount ? 'space-between' : 'center'};
  gap: 4px;
`;

export const StatusWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 4px;
  position: relative;
`;

// Text components
export const TransactionName = styled.span`
  display: flex;
  align-items: center;
  font-family: ${INTER.bold};
  color: ${DARK_VIOLET};
  font-size: 13px;
`;

export const DateText = styled.span`
  display: flex;
  align-items: center;
  font-family: ${INTER.regular};
  color: ${DARK_VIOLET};
  font-size: 13px;
`;

export const StatusText = styled.span<{ $status: string }>`
  color: ${({ $status }) => STATUS_COLOR[$status as keyof typeof STATUS_COLOR]};
  font-family: ${INTER.regular};
  font-size: 13px;
`;

export const AmountWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${INTER.extraBold};
  color: ${DARK_VIOLET};
  font-size: 13px;
`;

export const UnitText = styled.span`
  margin-left: 4px;
  font-family: ${INTER.regular};
  color: ${DARK_VIOLET};
  font-size: 13px;
`;
